import { Reveal, MaskLine } from "./Reveal";

export const PageHeader = ({ overline, lines, description, image, imageAlt }) => (
  <section data-testid="page-header" className="relative overflow-hidden bg-white pt-32 md:pt-44">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 pb-16 md:grid-cols-12 md:px-8 md:pb-24">
      <div className="md:col-span-7">
        <Reveal y={12}>
          <p className="font-overline flex items-center gap-3 text-[10px] uppercase tracking-[0.35em] text-[#e63946] md:text-[11px]">
            <span className="inline-block h-px w-10 bg-[#e63946]" />
            {overline}
          </p>
        </Reveal>
        <h1 className="font-display mt-6 text-[clamp(2.6rem,7vw,5.5rem)] font-extrabold leading-[0.98] tracking-tight text-[#111111]">
          {lines.map((line, i) => (
            <MaskLine key={i} delay={0.12 + i * 0.12}>
              {line}
            </MaskLine>
          ))}
        </h1>
        {description && (
          <Reveal delay={0.5} className="mt-8 max-w-xl">
            <p className="text-base leading-relaxed text-neutral-600 md:text-lg">{description}</p>
          </Reveal>
        )}
      </div>
      {image && (
        <div className="md:col-span-5">
          <Reveal delay={0.35} y={40}>
            <div className="clip-corner relative overflow-hidden">
              <img
                src={image}
                alt={imageAlt || ""}
                className="img-treatment aspect-[4/5] w-full object-cover"
                loading="eager"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/25 to-transparent" />
            </div>
          </Reveal>
        </div>
      )}
    </div>
  </section>
);
